import React from 'react';
import PropTypes from 'prop-types';
import AgentsTableControls from './AgentsTableControls';
import { listingProficiencyTooltips, tabModes } from '../../constants/agentProductionConstants';
import { getHeaderText } from '../../helpers/listingProficiencyHelpers';
import Table from '../../../common/components/table/agGrid/Table';
import { tableViews } from '../../../common/components/table/agGrid/tableViews';
import { useSearchStore } from '../../../store/store';
import { getSummaryPinnedConfig } from '../../../common/components/table/agGrid/pinnedRowSettings';
import { views } from '../../constants/savedAgents';
import AgentsFloatingActionBar from '../common/AgentsFloatingActionBar';
import { useAgentTableDownload } from '../../hooks/agentTableDownload';

const ListingProficiency = ({ agentData, additionalTableHeaders, setColumns, columns, state, setState, isActive }) => {
    const selectedModule = useSearchStore(state => state.selectedModule);
    const {
        summaryPinnedData,
    } = useSearchStore(state => ({
        summaryPinnedData: state[selectedModule]?.summaryPinnedData,
    }));

    const summaryPinnedConfig = getSummaryPinnedConfig(views.listingProficiency);
    const popoverHeader = getHeaderText();

    const {
        gridRef,
        selectedCount,
        showAddToListModal,
        setShowAddToListModal,
        handleDismiss,
        handleDownloadClick,
    } = useAgentTableDownload({ state, setState, selectedView: views.listingProficiency });

    const paramsTableControls = {
        columns,
        setColumns,
        tabMode: tabModes.LISTING_PROFICIENCY,
        popoverClassName: 'listing-proficiency',
        popoverHeader,
        hasShowHideColumnsButton: true,
        isTableSelected: true
    };

    const hasAdditionalTableHeaders = !!additionalTableHeaders.length;
    const classNameContainer = hasAdditionalTableHeaders ? '' : 'has-no-superheaders';

    return (
        <>
            <AgentsTableControls {...paramsTableControls} />
            <div className={classNameContainer}>
                <Table
                    gridRef={gridRef}
                    tableView={tableViews.listingProficiency}
                    rowData={agentData}
                    columns={columns}
                    additionalTableHeaders={additionalTableHeaders}
                    tableTitleWithTooltips={listingProficiencyTooltips}
                    pinnedBottomRowData={[{...summaryPinnedData}]}
                    externalParams={{summaryPinnedConfig}}
                    rowSelection={'multiple'}
                    suppressRowClickSelection={true}
                    rowMultiSelectWithClick={true}
                />
            </div>
            {isActive && (
                <AgentsFloatingActionBar
                    selectedCount={selectedCount}
                    showAddToListModal={showAddToListModal}
                    setShowAddToListModal={setShowAddToListModal}
                    onDismiss={handleDismiss}
                    onDownloadClick={handleDownloadClick}
                />
            )}
        </>
    );
};

ListingProficiency.propTypes = {
    agentData: PropTypes.arrayOf(PropTypes.object),
    additionalTableHeaders: PropTypes.arrayOf(PropTypes.object),
    columns: PropTypes.arrayOf(PropTypes.object),
    setColumns: PropTypes.func,
    state: PropTypes.object,
    setState: PropTypes.func,
    isActive: PropTypes.bool,
};

export default ListingProficiency;
